import React, { createContext, useState, useEffect } from "react";

// 1. Creamos el contexto
export const AuthContext = createContext();

// 2. Creamos el Provider que envolverá nuestra aplicación
export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [cargandoSesion, setCargandoSesion] = useState(true);

  // Validar sesión al cargar la app
  useEffect(() => {
    const usuarioGuardado = localStorage.getItem("usuario");
    if (usuarioGuardado) {
      try {
        const parsedUser = JSON.parse(usuarioGuardado);
        if (parsedUser && typeof parsedUser === "object" && (parsedUser.correo || parsedUser.cargo)) {
          setUsuario(parsedUser);
        } else {
          localStorage.removeItem("usuario");
        }
      } catch (e) {
        localStorage.removeItem("usuario");
      }
    }
    setCargandoSesion(false);
  }, []);

  // Función global para iniciar sesión
  const iniciarSesion = (userData) => {
    setUsuario(userData);
    localStorage.setItem("usuario", JSON.stringify(userData));
  };

  // Función global para cerrar sesión
  const cerrarSesion = () => {
    setUsuario(null);
    localStorage.removeItem("usuario");
  };

  // Calculamos permisos globales para tenerlos a la mano
  const correoAdmin = usuario?.correo?.toLowerCase().trim() || "";
  const cargoAdmin = usuario?.cargo?.toLowerCase().trim() || "";
  const rolAdmin = usuario?.rol?.toLowerCase().trim() || "";
  const esSuperAdmin = 
    correoAdmin === "admin@gmail.com" || 
    cargoAdmin === "super_admin" || cargoAdmin === "superadmin" ||
    rolAdmin === "super_admin" || rolAdmin === "superadmin";

  return (
    <AuthContext.Provider 
      value={{ 
        usuario, 
        cargandoSesion, 
        iniciarSesion, 
        cerrarSesion, 
        esSuperAdmin 
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};